import { _BaseButtonData, IButtonData } from './_base-button';

export class ButtonData
    extends _BaseButtonData
    implements IButtonData
{

    protected constructor(buttonData: IButtonData | null);
    protected constructor(sourceData: IButtonData, newData: IButtonData);
    protected constructor(sourceData: IButtonData | null, newData?: IButtonData) {
        super();

        const _buttonData = !!newData ? {...sourceData, ...newData} : sourceData ?? {};

        Object.assign(this, _buttonData);
    }

    static create(buttonData?: IButtonData | null): IButtonData | null {
        return !!buttonData ? new ButtonData(buttonData) : null;
    }
}
